
<div class=" gray-background content pt-3 px-3 pb-3">
    <campaign-package-preview></campaign-package-preview>
</div>